import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Setting } from '../../models/setting';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html'
})
export class DeleteDialogComponent implements OnInit {
  dialogTitle!: string;
  setting! : Setting;


  constructor(  public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {setting: Setting, title: string}) { }

  ngOnInit(): void {
    this.dialogTitle = this.data.title;
    if (this.data.setting != undefined) {
      this.setting = JSON.parse(JSON.stringify(this.data.setting));
    }
    
  }

  /**
   * Called when the delete action dialog is submitted.
   */
   onSubmit() {
    this.dialogRef.close(this.setting);
  }

}
